import Api from '../http.service';

// update profile logo
/**
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.id
 * @param {Object} payload.data.basicInfo
 * @param {String} payload.data.basicInfo.logo
 */
export const updateProfileLogo = (payload) =>
  Api.PUT({ data: payload.data, url: 'profile/logo' });

// create Buisness  profile
/**
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {Object} payload.data.basicInfo
 * @param {String} payload.data.basicInfo.phone
 * @param {String} payload.data.basicInfo.managerName
 * @param {String} payload.data.basicInfo.country
 * @param {String} payload.data.basicInfo.city
 * @param {String} payload.data.basicInfo.nationalCode
 * @param {String} payload.data.basicInfo.economicCode
 * @param {Array} payload.data.basicInfo.workingHours
 * @param {String} payload.data.basicInfo.console.logo
 * @param {Object} payload.data.displayName
 * @param {String} payload.data.displayName.en
 * @param {String} payload.data.displayName.fa
 * @param {String} payload.data.businessTypeId
 * @param {number} payload.data.role
 * @param {Array} payload.data.addresses
 */
export const createBusinessProfile = (payload) =>
  Api.POST({ data: payload.data, url: 'profile/create_business' });

// create Buisness  profile
/**
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {Number} payload.data.id
 * @param {Object} payload.data.basicInfo
 * @param {String} payload.data.basicInfo.phone
 * @param {String} payload.data.basicInfo.managerName
 * @param {String} payload.data.basicInfo.country
 * @param {String} payload.data.basicInfo.city
 * @param {String} payload.data.basicInfo.nationalCode
 * @param {String} payload.data.basicInfo.economicCode
 * @param {Array} payload.data.basicInfo.workingHours
 * @param {String} payload.data.basicInfo.console.logo
 * @param {Object} payload.data.displayName
 * @param {String} payload.data.displayName.en
 * @param {String} payload.data.displayName.fa
 * @param {String} payload.data.businessTypeId
 * @param {number} payload.data.role
 * @param {Array} payload.data.addresses
 */
export const update = (payload) =>
  Api.PUT({ data: payload.data, url: 'profile/me' });

// create Buisness  profile
/**
 * @param {Object} payload
 * @param {Number} payload.profileId
 * @param {Object} payload.data
 * @param {Number} payload.data.id
 * @param {Object} payload.data.basicInfo
 * @param {String} payload.data.basicInfo.phone
 * @param {String} payload.data.basicInfo.managerName
 * @param {String} payload.data.basicInfo.country
 * @param {String} payload.data.basicInfo.city
 * @param {String} payload.data.basicInfo.nationalCode
 * @param {String} payload.data.basicInfo.economicCode
 * @param {Array} payload.data.basicInfo.workingHours
 * @param {String} payload.data.basicInfo.console.logo
 * @param {Object} payload.data.displayName
 * @param {String} payload.data.displayName.en
 * @param {String} payload.data.displayName.fa
 * @param {String} payload.data.businessTypeId
 * @param {number} payload.data.role
 * @param {Array} payload.data.addresses
 */
export const updateIsLockProfile = (payload) =>
  Api.PATCH({
    data: payload.data,
    url: `/profile/profiles/${payload.profileId}`,
  });

/**
  //get all Company Types
 */
export const getCompanyTypes = () => Api.GET({ url: 'profile_type/all' });

// get information of profile
/**
 * @param {object} payload
 * @param {Number} payload.id
 * */
export const profileInfo = (payload) =>
  Api.GET({ url: `profile/business/${payload.id}` });

/**Invite employee
 * @param {Object} payload
 * @param {Object} payload.data
 *
 * @param {String}  payload.data.email
 * @param {Number}  payload.data.profileId
 * @param {Number}  payload.data.roleId
 * @param {Number}  payload.data.departmentId
 */
export const inviteEmployee = (payload) =>
  Api.PUT({ data: payload.data, url: 'profile/invitation/employee' });

/**Invite employee
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String}  payload.data.email
 */
export const inviteFriends = (payload) =>
  Api.PUT({ data: payload.data, url: 'profile/invitation/friend' });

export const invite = () => Api.GET({ url: 'profile/invited' });

/* change  profile avatar
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.avatar
 */
export const updateProfileAvatar = (payload) =>
  Api.PUT({ url: `profile/change_avatar`, data: payload.data });

/** get User CreditInfo
 * @param {Object} payload
 * @param {String} payload.avatar
 */
export const getUserCreditInfo = () =>
  Api.GET({ url: 'profile/credit_wallet_point_me' });

/** get activeProfile
 * @param {Object} payload
 * @param {number} payload.id
 */
export const activeProfile = (id) =>
  Api.POST({ url: `profile/active_profile/${id}` });

export const getMe = () => Api.GET({ url: 'profile/me' });

export const getBusinessType = () => Api.GET({ url: 'business_type/all' });
export const verifyToken = (token) =>
  Api.POST({ url: `profile/verifyToken`, data: { token } });
